<template>
  <div class="bg-white-snow">
    <!-- Mission Section -->
    <div
      class="grid grid-cols-1 gap-8 px-4 py-8 sm:gap-10 md:grid-cols-2 md:px-[50px] md:py-[50px] md:gap-[40px] lg:gap-[100px] lg:p-[100px]"
    >
      <!-- Image Section -->
      <div class="flex justify-between order-1 md:order-2 md:mb-0">
        <img
          class="w-full h-[250px] md:h-[500px] object-cover transition-shadow duration-300"
          :src="missionImage"
          alt="Mission Image"
        />
      </div>
      <!-- Content Section -->
      <div
        class="flex flex-col space-y-4 md:space-y-6 order-2 md:order-1 md:text-left"
      >
        <h1 class="text-2xl md:text-4xl font-semibold">
          {{ getLocalized1("mission") }}
        </h1>

        <p
          class="text-base md:text-xl max-w-full md:max-w-[425px] mx-auto md:mx-0 leading-relaxed"
        >
          {{ missionDescription }}
        </p>
      </div>
    </div>

    <!-- Vision Section -->
    <div
      class="grid grid-cols-1 gap-8 px-4 py-8 md:grid-cols-2 md:px-[50px] md:py-[50px] md:gap-[40px] lg:gap-[100px] lg:p-[100px]"
    >
      <!-- Image Section -->
      <div class="flex justify-between items-center mb-6 md:mb-0">
        <img
          class="w-full h-[250px] md:h-[500px] object-cover transition-shadow duration-300"
          :src="visionImage"
          alt="Vision Image"
        />
      </div>

      <!-- Content Section -->
      <div class="flex flex-col space-y-4 md:space-y-6 items-left md:text-left">
        <h1 class="text-2xl md:text-4xl font-semibold">
          {{ getLocalized1("vision") }}
        </h1>
        <p
          class="text-base md:text-xl max-w-full md:max-w-[425px] mx-auto md:mx-0 leading-relaxed"
        >
          {{ visionDescription }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    missionDescription: {
      type: String,
      required: true,
    },
    missionImage: {
      type: String,
      required: true,
    },
    visionDescription: {
      type: String,
      required: true,
    },
    visionImage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      translations: {
        mission: {
          en: "Mission",
          kh: "បេសកកម្ម",
        },
        vision: {
          en: "Vision",
          kh: "ចក្ខុវិស័យ",
        },
      },
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  computed: {
    getLocalized1() {
      return (key) => {
        return this.translations[key]
          ? this.translations[key][this.currentLang]
          : key;
      };
    },
  },
};
</script>

<style scoped>
.bg-white-snow {
  background-color: #f5f5f5;
}
</style>
